// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 7: 手紙と黙示録
// ============================================================================
// レベル79-91 (13レベル、39問)

export const chapter7Translations = {
  name: "手紙と黙示録",
  description: "勝利を得る者は、これらすべてのものを相続する... 上からの知恵は理解を聖別する",
  
  spiritualWisdom: {
    principle: "上からの知恵は理解を聖別し、霊を生かす",
    scripture: "あなたがたの中で知恵に欠けている人がいれば、神に願いなさい(ヤコブ1:5)",
    application: "すべての使徒の手紙と黙示録のすべての幻は、私たちの理解を豊かにし、希望を強めます"
  },
  
  levels: {
    79: {
      name: "エルサレムでの逮捕",
      challenge: "私は縛られることだけでなく、エルサレムで死ぬ覚悟もできています...",
      easy: {
        question: "パウロが最後の訪問で逮捕されたのはどこですか?",
        options: ["アンティオキア", "エフェソ", "エルサレム", "コリント"],
        correctAnswer: 2,
        hint: "しばしば預言者たちを迫害した聖なる都",
        funFact: "🏛️ エルサレム:神のすべてのしもべにとって栄光と苦難の場所!"
      },
      medium: {
        question: "ユダヤ人はパウロを何で告発しましたか?",
        options: [
          "神殿からの盗み",
          "異邦人を神殿に入れて神殿を冒涜した",
          "モーセへの冒涜",
          "ローマへの反逆"
        ],
        correctAnswer: 1,
        hint: "福音の普遍性に関連する告発",
        funFact: "⛪ 皮肉:パウロは深く尊敬していた神殿を冒涜したと告発された!"
      },
      hard: {
        question: "パウロはどのように投獄を機会に変えましたか?",
        options: [
          "逃げた",
          "当局の前で証言し、書簡を書いた",
          "沈黙した",
          "釈放を交渉した"
        ],
        correctAnswer: 1,
        hint: "試練を証しに変えることについて",
        funFact: "⛓️ 肉体の鎖、霊的自由 - 信仰の力強い証し!"
      }
    },
    
    80: {
      name: "総督ペリクスの前で",
      challenge: "義と節制と来るべき裁きについて論じたとき...",
      easy: {
        question: "パウロがどの総督の前で信仰を証ししましたか?",
        options: ["ピラト", "ペリクス", "フェストゥス", "ガリオ"],
        correctAnswer: 1,
        hint: "貪欲で知られる総督",
        funFact: "⚖️ ペリクスは賄賂を期待した - 誠実さの前の腐敗!"
      },
      medium: {
        question: "パウロのメッセージに対するペリクスの反応は?",
        options: [
          "改心した",
          "恐れて震えた",
          "嘲笑した",
          "無関心だった"
        ],
        correctAnswer: 1,
        hint: "真理に動揺した良心",
        funFact: "😰 腐敗した者でも神の真理の前で震える - 普遍的良心!"
      },
      hard: {
        question: "なぜペリクスはパウロを2年間投獄したのですか?",
        options: [
          "パウロを守るため",
          "政治的利害と腐敗の期待",
          "忘れていたから",
          "確信していたから"
        ],
        correctAnswer: 1,
        hint: "政治的および個人的計算について",
        funFact: "🏛️ 腐敗した人間の正義vs完璧な神の正義 - 鋭い対比!"
      }
    },

    81: {
      name: "カエサルへの上訴",
      challenge: "私はカエサルに上訴します!",
      easy: {
        question: "パウロがエルサレムでの裁判を避けるために何を主張しましたか?",
        options: [
          "亡命権",
          "カエサルへの上訴(ローマ市民)",
          "逃亡権",
          "外交保護"
        ],
        correctAnswer: 1,
        hint: "ローマ市民権の特権",
        funFact: "🏛️ ローマ市民権:福音をローマに運ぶ神のパスポート!"
      },
      medium: {
        question: "出発前、パウロは誰の前で証しをしましたか?",
        options: [
          "サンヘドリン",
          "アグリッパ王とベレニケ",
          "ローマの兵士たち",
          "ユダヤの群衆"
        ],
        correctAnswer: 1,
        hint: "ユダヤ化されたヘロデの王族",
        funFact: "👑 羊飼いから王宮へ - パウロの神的昇格!"
      },
      hard: {
        question: "神はどのように人間のシステムを計画に使いますか?",
        options: [
          "無視する",
          "摂理的に用いてご自分の計画を実現する",
          "破壊する",
          "常に反対する"
        ],
        correctAnswer: 1,
        hint: "歴史における神の主権について",
        funFact: "🌐 ローマの正義が福音の媒体になる - 驚くべき摂理!"
      }
    },

    82: {
      name: "マルタでの難破",
      challenge: "恐れるな、パウロよ。あなたはカエサルの前に立たなければならない...",
      easy: {
        question: "パウロがどの島で難破しましたか?",
        options: ["クレタ", "キプロス", "マルタ", "シチリア"],
        correctAnswer: 2,
        hint: "シチリアの南の小さな島",
        funFact: "🏝️ マルタ:強制停止が実り豊かな宣教になる - 神の回り道!"
      },
      medium: {
        question: "パウロはマルタでどんな奇跡を行いましたか?",
        options: [
          "嵐を静めた",
          "プブリオの父と他の病人を癒した",
          "食物を増やした",
          "死者を生き返らせた"
        ],
        correctAnswer: 1,
        hint: "島での複数の癒し",
        funFact: "🏥 パウロ:難破者から奇跡の医師へ - 神の評判!"
      },
      hard: {
        question: "この難破は神の真実をどう示していますか?",
        options: [
          "事故は起こる",
          "神は障害にもかかわらず約束を守り実現する",
          "パウロは運が良かった",
          "避けられた"
        ],
        correctAnswer: 1,
        hint: "約束への神の忠実さについて",
        funFact: "⛈️ 嵐、難破、蛇:何もパウロへの神の計画を止められない!"
      }
    },

    83: {
      name: "ローマのパウロ",
      challenge: "まる二年の間、自費で借りた家に住み...",
      easy: {
        question: "パウロはローマでどんな状況で暮らしましたか?",
        options: [
          "閉じた牢獄で",
          "自宅軟禁",
          "完全な自由で",
          "追放で"
        ],
        correctAnswer: 1,
        hint: "監視下での相対的自由",
        funFact: "🏠 家-牢獄が宣教センターになる - 鎖の中の自由!"
      },
      medium: {
        question: "パウロはローマでの2年間何をしましたか?",
        options: [
          "休んだ",
          "教え、書簡を書いた",
          "弁護の準備をした",
          "観光した"
        ],
        correctAnswer: 1,
        hint: "鎖にもかかわらず激しい奉仕",
        funFact: "✍️ 獄中書簡:エフェソ、ピリピ、コロサイ、ピレモン!"
      },
      hard: {
        question: "伝統によると、パウロはどのように奉仕を終えましたか?",
        options: [
          "病死",
          "紀元67年頃ネロの下で斬首された",
          "老衰で死んだ",
          "神秘的に消えた"
        ],
        correctAnswer: 1,
        hint: "狂気の皇帝の下での殉教",
        funFact: "⚔️ '良い戦いを戦い抜き、走るべき道のりを走り終えた' - 最終勝利!"
      }
    },

    84: {
      name: "ローマ人への手紙",
      challenge: "私は福音を恥としない。それは信じる者すべてに救いをもたらす神の力...",
      easy: {
        question: "どの書簡が信仰による救いの教義を最も展開していますか?",
        options: ["1コリント", "ガラテヤ", "ローマ", "エフェソ"],
        correctAnswer: 2,
        hint: "パウロの神学的'大聖堂'",
        funFact: "🏛️ ローマ書:アウグスティヌスとルターを改心させた神学的傑作!"
      },
      medium: {
        question: "ローマ書によると、人は神の前でどのように義とされますか?",
        options: [
          "善い行いによって",
          "信仰のみによって、行いなしで",
          "犠牲によって",
          "伝統によって"
        ],
        correctAnswer: 1,
        hint: "宗教改革の基本原理",
        funFact: "⚖️ '義人は信仰によって生きる' - パウロの霊的革命!"
      },
      hard: {
        question: "この書簡の普遍的範囲は何ですか?",
        options: [
          "ローマ人だけに関係する",
          "全人類のための救いの計画を説明する",
          "ローマのみを批判する",
          "時代遅れ"
        ],
        correctAnswer: 1,
        hint: "普遍的救いの計画について",
        funFact: "🌍 福音=すべての人への神の力:ユダヤ人もギリシア人も - 完全な普遍性!"
      }
    },

    85: {
      name: "愛の賛歌 - 1コリント13章",
      challenge: "たとえ人々の異言や天使の言葉を語っても、愛がなければ...",
      easy: {
        question: "聖書のどの章が'愛の賛歌'と呼ばれていますか?",
        options: [
          "1コリント12章",
          "1コリント13章",
          "1ヨハネ4章",
          "ローマ8章"
        ],
        correctAnswer: 1,
        hint: "1コリントの中心章",
        funFact: "💝 結婚式で最も読まれる章 - 愛の完璧な定義!"
      },
      medium: {
        question: "パウロは愛の持続性について何と言っていますか?",
        options: [
          "愛は時間とともに過ぎ去る",
          "愛は決して絶えることがない",
          "愛は状況による",
          "愛は一時的"
        ],
        correctAnswer: 1,
        hint: "神の愛の永遠性",
        funFact: "♾️ 愛だけが死と永遠を越える - 最高の価値!"
      },
      hard: {
        question: "なぜパウロは愛を霊的賜物の上に置くのですか?",
        options: [
          "賜物は悪い",
          "愛はすべてのものに意味と価値を与える",
          "愛はより簡単",
          "賜物は分裂させる"
        ],
        correctAnswer: 1,
        hint: "すべての奉仕の原動力と意味について",
        funFact: "🎯 愛なしでは、最大の賜物でも騒音と高慢になる!"
      }
    },

    86: {
      name: "エフェソ:キリストの体である教会",
      challenge: "すべてのものをその足の下に従わせ、教会にすべてのものの上にかしらとして与えられました...",
      easy: {
        question: "エフェソ書によると、教会はキリストとの関係で何ですか?",
        options: [
          "その神殿",
          "その体",
          "その家族",
          "その軍隊"
        ],
        correctAnswer: 1,
        hint: "一致の有機的メタファー",
        funFact: "👤 キリストの体:すべてのクリスチャンは不可欠な部分 - 相互依存!"
      },
      medium: {
        question: "パウロは霊的戦いのためにどんな武具を描写していますか?",
        options: [
          "物理的武具",
          "神の武具:真理、正義、平和、信仰、救い、御言葉",
          "ローマの武具",
          "魔法の保護"
        ],
        correctAnswer: 1,
        hint: "6つの霊的武具",
        funFact: "⚔️ 霊的戦闘には霊的武器 - 勝利の神の戦略!"
      },
      hard: {
        question: "パウロによると、私たちの本当の戦いは何に対してですか?",
        options: [
          "悪い人間に対して",
          "悪の霊的勢力に対して",
          "政府に対して",
          "貧困に対して"
        ],
        correctAnswer: 1,
        hint: "見えない霊的力について",
        funFact: "👹 宇宙的戦闘:人間の対立の背後に本当の霊的戦争がある!"
      }
    },

    87: {
      name: "ピリピ:試練の中の喜び",
      challenge: "主において常に喜びなさい。重ねて言います。喜びなさい!",
      easy: {
        question: "パウロは投獄されているにもかかわらず、どんな感情を勧めていますか?",
        options: ["諦め", "喜び", "怒り", "悲しみ"],
        correctAnswer: 1,
        hint: "囚人にとって驚くべき感情",
        funFact: "😊 4章で16回の喜び - 牢獄での幸福記録!"
      },
      medium: {
        question: "ピリピ2章によると、イエスはどんな態度を取りましたか?",
        options: [
          "力で押し付けた",
          "へりくだり死に至るまで自分を低くした",
          "責任から逃げた",
          "栄光を求めた"
        ],
        correctAnswer: 1,
        hint: "自発的な下降運動",
        funFact: "📉 イエス:神との同等性から十字架の死まで - 極度の愛!"
      },
      hard: {
        question: "パウロはどうして牢獄で喜びを説けるのですか?",
        options: [
          "偽っている",
          "キリスト教の喜びは状況を超越する",
          "マゾヒスト",
          "現実を否定している"
        ],
        correctAnswer: 1,
        hint: "超自然的な喜びについて",
        funFact: "✨ 喜び=状況に関係なく御霊の実 - 神の秘訣!"
      }
    },

    88: {
      name: "牧会書簡",
      challenge: "信仰の戦いを立派に戦い抜き、永遠の命を手に入れなさい...",
      easy: {
        question: "パウロは最後の牧会書簡を誰に書きましたか?",
        options: [
          "コリント人に",
          "テモテとテトスに",
          "ローマ人に",
          "ガラテヤ人に"
        ],
        correctAnswer: 1,
        hint: "彼の霊的子供たちと協力者",
        funFact: "👨‍👦 霊的遺言:パウロは次世代にたいまつを渡す!"
      },
      medium: {
        question: "パウロは教会の指導者を選ぶためにどんなアドバイスをしますか?",
        options: [
          "最も裕福な人を選ぶ",
          "厳格な道徳的・霊的基準に従って選ぶ",
          "最も教育された人を選ぶ",
          "最も人気のある人を選ぶ"
        ],
        correctAnswer: 1,
        hint: "何よりもまず道徳的資格",
        funFact: "⚖️ 指導者の高い基準:能力の前に品性 - 神の優先順位!"
      },
      hard: {
        question: "パウロはテモテにどんな遺産を残しますか?",
        options: [
          "物質的財産",
          "福音への忠実さと牧会的奉仕",
          "政治的役職",
          "神学校"
        ],
        correctAnswer: 1,
        hint: "霊的遺産について",
        funFact: "📜 '良い預かり物を守りなさい' - 世紀を通じた福音の忠実な伝達!"
      }
    },

    89: {
      name: "ヘブライ:イエス大祭司",
      challenge: "天を通られた偉大な大祭司がおられます...",
      easy: {
        question: "ヘブライ書によると、私たちの偉大な大祭司は誰ですか?",
        options: ["アロン", "モーセ", "イエス", "メルキゼデク"],
        correctAnswer: 2,
        hint: "神と人との完全な仲介者",
        funFact: "✝️ イエス:祭司であり犠牲 - 一度限りの完璧な犠牲!"
      },
      medium: {
        question: "なぜイエスの祭司職はアロンのものより優れているのですか?",
        options: [
          "より古いから",
          "メルキゼデクの位に従って永遠だから",
          "より裕福だから",
          "より人気があるから"
        ],
        correctAnswer: 1,
        hint: "永遠性vs一時性",
        funFact: "♾️ 永遠の祭司職:イエスは私たちのために永遠にとりなしをしてくださる!"
      },
      hard: {
        question: "ヘブライ書は新しい契約をどう示していますか?",
        options: [
          "古いものと同じ",
          "優れていて最終的、心に書かれている",
          "一時的",
          "任意"
        ],
        correctAnswer: 1,
        hint: "成就と超越について",
        funFact: "📋 新しい契約:石ではなく心に書かれた律法!"
      }
    },

    90: {
      name: "ヤコブ:信仰と行い",
      challenge: "行いの伴わない信仰は死んでいる...",
      easy: {
        question: "ヤコブによると、信仰に何が伴うべきですか?",
        options: [
          "言葉",
          "行い",
          "感情",
          "知識"
        ],
        correctAnswer: 1,
        hint: "信仰の実践的表れ",
        funFact: "🌳 信仰=根、行い=実 - 完全な霊的木!"
      },
      medium: {
        question: "ヤコブは舌を何にたとえていますか?",
        options: [
          "剣",
          "大きな森を焼く小さな火",
          "楽器",
          "道具"
        ],
        correctAnswer: 1,
        hint: "小さな部分だが大きな破壊力",
        funFact: "🔥 舌:小さな部分だが人生全体を燃やせる - 注意!"
      },
      hard: {
        question: "信仰/行いについてヤコブとパウロをどう調和させますか?",
        options: [
          "矛盾している",
          "パウロは義認について、ヤコブは聖化について語る",
          "一方が間違っている",
          "解決策はない"
        ],
        correctAnswer: 1,
        hint: "二つの補完的側面について",
        funFact: "⚖️ パウロ:信仰によって救われる / ヤコブ:行いによって証明される信仰 - 完璧な調和!"
      }
    },

    91: {
      name: "黙示録:王の帰還",
      challenge: "見よ、私はすぐに来る。この書の預言の言葉を守る者は幸い!",
      easy: {
        question: "黙示録でヨハネは何の教会に書いていますか?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "完全性の数",
        funFact: "⛪ アジアの7つの教会:すべての時代のすべての教会の鏡!"
      },
      medium: {
        question: "黙示録によると、歴史はどう終わりますか?",
        options: [
          "完全な破壊",
          "新しい天と新しい地",
          "地上の楽園への回帰",
          "すべての存在の終わり"
        ],
        correctAnswer: 1,
        hint: "創造の完全な更新",
        funFact: "🌅 世界の終わりではなく完全な更新 - 究極の希望!"
      },
      hard: {
        question: "黙示録は迫害されている者に何を伝えていますか?",
        options: [
          "降伏しなさい",
          "キリストは支配し、最終的に勝利する",
          "迫害から逃げなさい",
          "復讐しなさい"
        ],
        correctAnswer: 1,
        hint: "最終的勝利の希望について",
        funFact: "👑 '昔いまし、今いまし、やがて来られる方' - 歴史と時間の主!"
      }
    }
  }
};

export default chapter7Translations;
